module.exports = __webpack_public_path__ + "static/media/5DPO18.f3bb22a7.jpg";